"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAZY_LOAD_IMG_THRESHOLD = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var classnames_1 = __importDefault(require("classnames"));
var Product_1 = __importDefault(require("./Product"));
var Error_1 = __importDefault(require("../../common/Error"));
var track_event_1 = __importDefault(require("../../../utils/track-event"));
var atoms_1 = require("../../styles/atoms");
var selectors_1 = require("../../common/selectors");
var selectors_2 = require("../selectors");
var PopupForm_1 = __importStar(require("../../common/PopupForm"));
var styled_components_1 = __importDefault(require("styled-components"));
var axios_1 = __importDefault(require("axios"));
var constants_1 = require("../constants");
exports.LAZY_LOAD_IMG_THRESHOLD = 4;
var Products = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var onPlatform = (0, react_redux_1.useSelector)(selectors_1.onPlatformSelector);
    var products = (0, react_redux_1.useSelector)(selectors_2.productsSelector);
    var authenticityToken = (0, react_redux_1.useSelector)(selectors_1.authenticityTokenSelector);
    var tags = (0, selectors_2.useTagsSelector)();
    var _a = (0, react_1.useState)(false), modalIsOpen = _a[0], setModalIsOpen = _a[1];
    var _b = (0, react_1.useState)(''), productId = _b[0], setProductId = _b[1];
    (0, react_1.useEffect)(function () {
        if (!products.loaded || products.fromFavoritesUpdate)
            return;
        var productIds = products.items
            .map(function (product) { return product.id; })
            .join(',');
        (0, axios_1.default)("/profile/favorites/statuses.json?ids=".concat(productIds))
            .then(function (res) {
            var favIdsMap = res.data;
            products.items = products.items.map(function (product) {
                var _a;
                product.isFavorite = (_a = favIdsMap[product.id]) !== null && _a !== void 0 ? _a : false;
                return product;
            });
            dispatch({
                payload: { items: products.items },
                type: constants_1.UPDATE_PRODUCTS,
            });
        })
            .catch(console.error);
    }, [products]);
    var openModal = function (e) {
        e.stopPropagation();
        e.preventDefault();
        var productId = e.currentTarget.dataset.id;
        setModalIsOpen(true);
        setProductId(productId || '');
        (0, track_event_1.default)({
            category: 'store button',
            action: 'buy_in_one_click_product',
        });
    };
    var closeModal = function () {
        setModalIsOpen(false);
    };
    var isLazyLoadImg = function (idx) {
        if (!products.items)
            return false;
        return idx > exports.LAZY_LOAD_IMG_THRESHOLD;
    };
    var thankYouPage = function () {
        setTimeout(function () {
            location.pathname = '/thank_you';
        }, 700);
    };
    var loading = products.loading && !products.loaded;
    var error = products.error;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(atoms_1.Div, { visible: !!error, className: "col-xs-12" },
            react_1.default.createElement(Error_1.default, null)),
        react_1.default.createElement(ProductsContainer, { className: (0, classnames_1.default)('products', 'col-xs-12', { loading: loading }) },
            products.items.map(function (product, idx) { return (react_1.default.createElement(Product_1.default, { key: product.id, product: product, openModal: openModal, authenticityToken: authenticityToken, tags: tags, onPlatform: onPlatform, lazyImg: isLazyLoadImg(idx) })); }),
            react_1.default.createElement(PopupForm_1.default, { authToken: authenticityToken, open: modalIsOpen, onClose: closeModal, onSubmit: thankYouPage, productId: productId, formName: PopupForm_1.BUY_ONECLICK_FORM, requestName: "/one_click_orders", title: "\u041A\u0443\u043F\u0438\u0442\u044C \u0432 1 \u043A\u043B\u0438\u043A", btnTitle: "\u041E\u0424\u041E\u0420\u041C\u0418\u0422\u042C \u0417\u0410\u041A\u0410\u0417" }))));
};
var ProductsContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-top: 20px;\n"], ["\n  padding-top: 20px;\n"])));
exports.default = Products;
var templateObject_1;
